export const siteSettings = {
  name: "Nexus Trade Hub",
  link: "https://nexustradeshub.live",
  email: "support@nexustradeshub.live",
  appLink: "https://app.nexustradeshub.live",
};
